import { HEADERS_JSON } from '@/common/api/config';
import { CommonResponse } from '@/common/api/types';
import { catchError } from '@/common/api/utils';
import { GATEWAY_URL } from '@/config';
import { NotificationResponse } from '@/pages/Notifications/types';

export const fetchNotifications = async (
  token: string
): Promise<NotificationResponse> => {
  const response = await fetch(
    `${GATEWAY_URL}/cabinet/notifications?token=${token}`,
    {
      method: 'GET',
      headers: HEADERS_JSON,
    }
  );
  await catchError(response);
  return await response.json();
};

export const postNotificationConfirm = async ({
  token,
  id,
}: {
  token: string;
  id: number;
}): Promise<CommonResponse> => {
  const response = await fetch(
    `${GATEWAY_URL}/cabinet/notifications/confirm?token=${token}`,
    {
      method: 'POST',
      headers: HEADERS_JSON,
      body: JSON.stringify({ id }),
    }
  );
  await catchError(response);
  return await response.json();
};
